/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RdSAPFloorDimensionsV0 } from './rdSAPFloorDimensionsV0';


export interface RdSAPBuildingPartUIDTOV0 { 
    /**
     * The numerical identifier of the building part.
     */
    buildingPartNumber?: number;
    /**
     * An identifier for the building part, like \'Main dwelling\'.
     */
    identifier?: string;
    /**
     * The age band of the building part.
     */
    buildingPartAge?: string;
    /**
     * The type of construction of the party wall.
     */
    partyWallConstruction?: string;
    /**
     * The type of construction of the walls.
     */
    wallsConstruction?: string;
    /**
     * Indicates if the wall thickness has been measured.
     */
    wallThicknessMeasured?: boolean;
    /**
     * Indicates if the U-Value is known.
     */
    uValueknown?: boolean;
    /**
     * The type of insulation in the walls.
     */
    wallsInsulationType?: number;
    /**
     * The thickness of the wall insulation.
     */
    wallsInsulationThickness?: string;
    /**
     * The thickness of the walls.
     */
    wallsWallThickness?: number;
    /**
     * Indicates if the walls are dry-lined.
     */
    wallsDryLined?: boolean;
    /**
     * The U-Value of the walls.
     */
    wallsUValue?: number;
    /**
     * The construction type of any additional walls.
     */
    additionalWallsConstruction?: string;
    /**
     * The insulation type used in any additional walls.
     */
    additionalWallsInsulationType?: string;
    /**
     * The thickness of the insulation in any additional walls.
     */
    additionalWallsInsulationThickness?: string;
    /**
     * The thickness of any additional walls.
     */
    additionalWallsWallThickness?: number;
    /**
     * The area of any additional walls.
     */
    additionalWallWallArea?: number;
    /**
     * Indicates if the thickness of any additional walls has been measured.
     */
    additionalWallThicknessMeasured?: boolean;
    /**
     * Indicates if the U-value of any additional walls is known.
     */
    additionalWallUValueKnown?: boolean;
    /**
     * Indicates if any additional walls are dry-lined.
     */
    additionalWallsDryLined?: boolean;
    /**
     * The U-value of any additional walls.
     */
    additionalWallsUValue?: number;
    /**
     * Indicates if any additional walls are considered sheltered.
     */
    shelteredWall?: boolean;
    /**
     * The construction type of the roof.
     */
    roofConstruction?: string;
    /**
     * The location/type of roof insulation.
     */
    roofInsulationType?: string;
    /**
     * The thickness of the roof insulation. Only one of roofUValue, roofInsulationThickness, rafterInsulationThickness, flatRoofInsulationThickness or slopingCeilingInsulationThickness should be set.
     */
    roofInsulationThickness?: string;
    /**
     * Only one of roofUValue, roofInsulationThickness, rafterInsulationThickness, flatRoofInsulationThickness or slopingCeilingInsulationThickness should be set.
     */
    rafterInsulationThickness?: string;
    /**
     * Only one of roofUValue, roofInsulationThickness, rafterInsulationThickness, flatRoofInsulationThickness or slopingCeilingInsulationThickness should be set.
     */
    flatRoofInsulationThickness?: string;
    /**
     * Only one of roofUValue, roofInsulationThickness, rafterInsulationThickness, flatRoofInsulationThickness or slopingCeilingInsulationThickness should be set.
     */
    slopingCeilingInsulationThickness?: string;
    /**
     * The U-value of the roof. Only one of roofUValue, roofInsulationThickness, rafterInsulationThickness, flatRoofInsulationThickness or slopingCeilingInsulationThickness should be set.
     */
    roofUValue?: number;
    /**
     * Indicates if the U-value of the roof is known.
     */
    roofUValueKnown?: boolean;
    /**
     * Description of the floor heat loss characteristic.
     */
    floorHeatLossType?: string;
    /**
     * The construction type of the floor.
     */
    floorConstruction?: string;
    /**
     * The insulation type used in the floor.
     */
    floorInsulationType?: string;
    /**
     * The thickness of the floor insulation.
     */
    floorInsulationThickness?: string;
    /**
     * The U-value of the floor.
     */
    floorUValue?: number;
    /**
     * Indicates if the U-value of the floor is known.
     */
    floorUValueKnown?: boolean;
    /**
     * The total area of rooms within the roof space, if applicable.
     */
    roofRoomsArea?: number;
    /**
     * The age band of rooms within the roof space, if applicable.
     */
    roofRoomsAge?: string;
    /**
     * The type of insulation in rooms within the roof space, if applicable.
     */
    roofRoomsInsulation?: string;
    /**
     * The thickness of insulation in rooms within the roof space, if applicable.
     */
    roofRoomsThickness?: string;
    /**
     * Indicates if the rooms in the roof are adjoining with any structure.
     */
    roofRoomsAdjoining?: boolean;
    /**
     * The area of the first flat ceiling section within the roof.
     */
    flatCeilingOneArea?: number;
    /**
     * The U-value of the first flat ceiling section within the roof.
     */
    flatCeilingOneUValue?: number;
    /**
     * The area of the first sloped section within the roof.
     */
    slopeOneArea?: number;
    /**
     * The U-value of the first sloped section within the roof.
     */
    slopeOneUValue?: number;
    /**
     * The area of the first stud wall section within the roof.
     */
    studWallOneArea?: number;
    /**
     * The U-value of the first stud wall section within the roof.
     */
    studWallOneUValue?: number;
    /**
     * The area of the second flat ceiling section within the roof space.
     */
    flatCeilingTwoArea?: number;
    /**
     * The U-value of the second flat ceiling section within the roof space.
     */
    flatCeilingTwoUValue?: number;
    /**
     * The area of the second sloped section within the roof space.
     */
    slopeTwoArea?: number;
    /**
     * The U-value of the second sloped section within the roof space.
     */
    slopeTwoUValue?: number;
    /**
     * The area of the second stud wall section within the roof space.
     */
    studWallTwoArea?: number;
    /**
     * The U-value of the second stud wall section within the roof space.
     */
    studWallTwoUValue?: number;
    /**
     * The area of the first gable wall section within the roof space.
     */
    gableWallOneArea?: number;
    /**
     * The U-value of the first gable wall section within the roof space.
     */
    gableWallOneUValue?: number;
    /**
     * The area of the second gable wall section within the roof space.
     */
    gableWallTwoArea?: number;
    /**
     * The U-value of the second gable wall section within the roof space.
     */
    gableWallTwoUValue?: number;
    /**
     * A list containing the floor dimensions and related details.
     */
    dimensionsArray?: Array<RdSAPFloorDimensionsV0>;
}

